import React from 'react';

const RESOURCES = [
  {
    icon: '📄',
    label: 'Full Wanderhome PDF',
    href: 'https://drive.google.com/file/d/1VrdWroB2CcaPMFkZxjxezDcCrP7x0gr8/view?usp=sharing',
  },
  {
    icon: '📚',
    label: 'Bonus Playbooks',
    href: 'https://drive.google.com/file/d/1lcMO7SXHLLeULIhe--Nk3_oj2ty3uOiB/view?usp=sharing',
  },
  {
    icon: '🎙️',
    label: 'Intro Walkthrough',
    href: 'https://share.descript.com/view/xI06zZTqDov',
  },
];

export default function Header() {
  return (
    <header className="text-center pt-9 pb-7 px-4">
      <div className="font-lora text-sm text-ink-light tracking-[0.2em] mb-1.5 italic">
        a living record of
      </div>
      <h1 className="font-playfair text-[clamp(1.8rem,4vw,2.8rem)] font-bold text-ink">
        The Wanderhome Repository
      </h1>
      <div className="font-lora text-lg text-ink-light tracking-[0.3em] mt-2 mb-5">
        ✦ ✦ ✦
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3">
        {RESOURCES.map((r) => (
          <a
            key={r.label}
            href={r.href}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 bg-parchment-mid border-[1.5px] border-parchment-dark rounded-full px-4 py-1.5 font-lora text-[0.82rem] text-ink-mid transition-all hover:bg-ink hover:text-parchment hover:border-ink hover:-translate-y-[1px] shadow-card"
          >
            <span>{r.icon}</span>
            <span>{r.label}</span>
            <span className="text-[0.7rem] opacity-50">↗</span>
          </a>
        ))}
      </div>
    </header>
  );
}